module.exports = function() {
  return new Worker(__webpack_public_path__ + "4506c296da56622fb00e.worker.js");
};